import React from 'react';
import { CityLogo } from '../ui/icons';

const Footer = () => {
    return (
        <footer className="bck_green">
            <div className="footer_logo">
                <CityLogo
                    width="50px"
                    height="50px"
                />
            </div>
            <div className="footer_discl">
                Hackathon 2019
            </div>
            
        </footer>
    );
};

export default Footer;


// WEBPACK FOOTER //
// ./src/Components/Header_footer/Footer.js